import {ISkeleton} from '../../interfaces/skeleton';
import {SkeletonTypeEnum} from '../../enums/skeleton';

export const UtilityPanelStatisticsSkeleton: ISkeleton[] = [
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    classes: 'mt-md',
    style: 'width:100%; height: 32px;',
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.TEXT,
    style: 'width: 100%',
    rows: 2,
  },
  {
    multiple: true,
    style: 'width: 100%',
    items: [
      {
        type: SkeletonTypeEnum.INPUT,
        classes: 'mb-sm mr-sm',
        style: 'width: calc(50% - 8px); height: 100px;',
      },
      {
        type: SkeletonTypeEnum.INPUT,
        classes: 'mb-sm',
        style: 'width: calc(50% - 8px); height: 100px;',
      },
    ],
  },
  {
    multiple: true,
    style: 'width: 100%',
    items: [
      {
        type: SkeletonTypeEnum.INPUT,
        classes: 'mb-sm mr-sm',
        style: 'width: calc(50% - 8px); height: 100px;',
      },
      {
        type: SkeletonTypeEnum.INPUT,
        classes: 'mb-sm',
        style: 'width: calc(50% - 8px); height: 100px;',
      },
    ],
  },
];
